var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkToIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0031 7.0605L5.5478 13.5157L4.4873 12.4553L10.9418 6H5.25305V4.5H13.5031V12.75H12.0031V7.0605Z",
    fill: "#414251"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkToIcon);
export default __webpack_public_path__ + "static/media/link_to_icon.bde6130f524a12888b1cf8cd5a703d33.svg";
export { ForwardRef as ReactComponent };